var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5597_2755)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58161 0 0 3.58161 0 8C0 12.4184 3.58161 16 8 16C12.4184 16 16 12.4184 16 8C16 3.58161 12.4184 0 8 0ZM8 0.800009C8.94684 0.79794 9.88479 0.982646 10.7601 1.34355C11.6355 1.70446 12.4311 2.23448 13.1013 2.90327C13.7716 3.57205 14.3033 4.36647 14.6662 5.24104C15.029 6.11561 15.2157 7.05316 15.2157 8C15.2157 8.94684 15.029 9.88439 14.6662 10.759C14.3033 11.6335 13.7716 12.4279 13.1013 13.0967C12.4311 13.7655 11.6355 14.2955 10.7601 14.6564C9.88479 15.0174 8.94684 15.2021 8 15.2C6.09317 15.1958 4.26586 14.4354 2.919 13.0856C1.57214 11.7358 0.815723 9.90683 0.815723 8C0.815723 6.09316 1.57214 4.2642 2.919 2.91439C4.26586 1.56458 6.09317 0.804175 8 0.800009Z",
    fill: "#9A9AAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57145 6.18183V12H7.42859V6.18181L8.57145 6.18183ZM8.57145 4V5.09091H7.42859V4H8.57145Z",
    fill: "#9A9AAF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5597_2755"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon3);
export default __webpack_public_path__ + "static/media/info-icon-3.b43d73372f6673eb6dce5c6d71d0eea9.svg";
export { ForwardRef as ReactComponent };